import {Controller} from "stimulus"
import EventEmitter from "../utils/EventEmitter"
import flatpickr from "flatpickr"
import {French} from "flatpickr/dist/l10n/fr.js"
import {Dutch} from "flatpickr/dist/l10n/nl.js"
import fr from 'moment/locale/fr'
import en from 'moment/locale/en-gb'
import nl from 'moment/locale/nl-be'
import moment from 'moment'

export default class extends Controller {

    static targets = [
        "fromInput",
        "toInput",
        "fromMonthStr",
        "toMonthStr",
        "fromDayStr",
        "toDayStr",
    ]

    initialize() {

        const lang = document.querySelector("html").dataset.lang
        this.lang = lang ? lang : "fr"

        moment.locale(this.lang)

        this.flatpickrLocals = {
            "fr": French,
            "en": undefined,
            "nl": Dutch,
        }

        this.fromDefaultDate = this.fromInputTarget.dataset.date
        this.fromDefaultDate = this.fromDefaultDate && this.fromDefaultDate !== "" ? this.fromDefaultDate : undefined;

        this.toDefaultDate = this.toInputTarget.dataset.date
        this.toDefaultDate = this.toDefaultDate && this.toDefaultDate !== "" ? this.toDefaultDate : undefined;

        this.pickrFrom = this.initPickr(this.fromInputTarget, {
            defaultDate: this.fromDefaultDate,
        })

        this.pickrTo = this.initPickr(this.toInputTarget, {
            defaultDate: this.toDefaultDate
        })

        if (!this.toDefaultDate) {
            this.pickrTo.setDate(this.getNextDay(new Date()))
        }

        const onChange = [

        ]

        this.pickrFrom.config.onChange = []

        this.pickrTo.config.onChange = []

        this.pickrTo.config.onChange.push((selectedDates) => {

            if (!selectedDates[0]) {
                return;
            }

            let date = selectedDates[0]
            this.toMonthStrTarget.innerHTML = moment(date).format("MMMM")
            this.toDayStrTarget.innerHTML = moment(date).format("DD")

        })

        this.pickrFrom.config.onChange.push((selectedDates) => {

            if (!selectedDates[0]) {
                return;
            }

            let date = selectedDates[0]
            this.fromMonthStrTarget.innerHTML = moment(date).format("MMMM")
            this.fromDayStrTarget.innerHTML = moment(date).format("DD")

            const nextDay = this.getNextDay(date)
            this.pickrTo.setDate(nextDay)
            this.toMonthStrTarget.innerHTML = moment(nextDay).format("MMMM")
            this.toDayStrTarget.innerHTML = moment(nextDay).format("DD")

        })

        const name = this.name

        EventEmitter.on(`from-to${(name !== "" ? "-" + name : "")}-should-change-dates`, ({detail}) => {
            const {dateFromStr, dateToStr} = detail
            this.pickrFrom.setDate(moment(dateFromStr, "DD/MM/YYYY").toDate())
            this.pickrTo.setDate(moment(dateToStr, "DD/MM/YYYY").toDate())
        })

    }

    get name() {
        let name = this.data.get("name")
        name = !name ? "" : name;
        return name;
    }

    openTo(){
        this.pickrTo.open()
    }

    openFrom(){
        this.pickrFrom.open()
    }

    getNextDay(date) {
        return moment(date).add(1, 'days').toDate()
    }

    getPrevDay(date) {
        return moment(date).subtract(1, 'days').toDate()
    }

    initPickr($target, userOptions) {

        let options = {
            locale: this.flatpickrLocals[this.lang],
            altInput: true,
            dateFormat: "d/m/Y",
            altFormat: "j F, Y",
            enable: [date => {
                const yesterday = moment(new Date()).subtract(1, "days")
                const loopDate = moment(date)
                return loopDate.isAfter(yesterday, 'day')
            }],
        }

        if (userOptions) {
            options = Object.assign({}, options, userOptions)
        }

        /**
         * For input date
         */
        if (!options.defaultDate) {
            const date = new Date()
            options.defaultDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
        }

        return new flatpickr($target, options)

    }


}